module.exports = __webpack_public_path__ + "static/img/banner.cafae49.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wolves/banner.png
// module id = L+LW
// module chunks = 1